import logo from './logo.svg';
import './App.css';
import * as React from 'react';
import Nav from './components/Nav';
import Box from '@mui/material/Box';
import Router from './router/index.js';
function App() {
  return (
    <Router />
  );
}

export default App;
